<template>
  <div class='myPostIndex'>

    <div class="paginationBox">
      <el-pagination
        :page-size="postPageSize"
        :pager-count="11"
        :current-page="postPageNum"
        layout="prev, pager, next"
        :total="postPageTotle"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <div
      class='cont'
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    >
    <div class="dsbox">
      <el-select
        v-model="roleLable"
        placeholder="请选择用户身份"
        @change="changeRoleLable"
      >
        <el-option
          v-for="item in roleLableArray"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="roleLevle"
        placeholder="请选择用户级别"
        @change="changeRoleLevle"
      >
        <el-option
          v-for="item in roleLevleArray"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-input style="width: 300px" v-model="phone" placeholder="请输入用户手机号码进行查询" @change="changeRoleLevle"></el-input>
    </div>
      <div class="tableCont">
        <el-table
          :data="postList"
          border
          style="width: 100%"
          :row-key="function(e){
                return e.id
            }"
        >
          <el-table-column
            prop="id"
            label="id"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="nickname"
            label="昵称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="phone"
            label="手机号码"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="resumNumber"
            label="简历数量"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="roleLable"
            label="用户身份"
            align="center"
          >
            <template slot-scope="scope">
              {{Number(scope.row.roleLable)=== 0 ? '未选择' : ''}}
              {{Number(scope.row.roleLable)=== 1 ? '猎头' : ''}}
              {{Number(scope.row.roleLable)=== 2 ? '推荐人' : ''}}
              {{Number(scope.row.roleLable)=== 3 ? '自荐人' : ''}}
            </template>
          </el-table-column>
          <el-table-column
            prop="roleLevle"
            label="角色等级"
            align="center"
          >
            <template slot-scope="scope">
              {{Number(scope.row.roleLevle)=== 0 ? '未认证' : ''}}
              {{Number(scope.row.roleLevle)=== 1 ? '初级顾问' : ''}}
              {{Number(scope.row.roleLevle)=== 2 ? '高级顾问' : ''}}
              {{Number(scope.row.roleLevle)=== 3 ? '合伙人' : ''}}

            </template>
          </el-table-column>
          <el-table-column
            prop="inviationnickname"
            label="邀请人昵称"
            align="center"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                @click="ckmorePeople(scope.row.id)"
              >查看他邀请的人</el-button>
            </template>
          </el-table-column>
        </el-table>

      </div>

    </div>
    <el-dialog
      title="邀请的人"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <div
        v-loading="loading1"
        style="height: 400px;overflow: hidden;overflow-y: scroll"
      >
        {{peoList.length === 0 ? '邀请人为空' : ''}}
        <div
          v-for="item in peoList"
          :key="item.id"
        >{{item.invitationNickname + ',' + item.phone + ',简历上传数量：' + item.resumNumber}}</div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="dialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import Config from "../config/index";
export default {
  name: "userList",
  props: {},
  data() {
    return {
      loading: false,
      postStatus: "1",
      postList: [],
      peoList: [],
      postPageNum: 1,
      postPageSize: 10,
      postPageTotle: 0,
      QrUrl: "",
      qrdialogVisible: false,
      dialogVisible: false,
      loading1: false,
      phone: "",
      roleLableArray: [
        {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "未选择"
        },
        {
          value: "1",
          label: "猎头"
        },
        {
          value: "2",
          label: "推荐人"
        },
        {
          value: "3",
          label: "自荐人"
        }
      ],
      roleLable: "",
      roleLevleArray: [
         {
          value: "",
          label: "全部"
        },
        {
          value: "0",
          label: "未认证"
        },
        {
          value: "1",
          label: "初级顾问"
        },
        {
          value: "2",
          label: "高级顾问"
        },
        {
          value: "3",
          label: "合伙人"
        }
      ],
      roleLevle: ""
    };
  },
  watch: {},
  created: function() {},
  methods: {
    changeRoleLable: function () {
      this.pageNum = 1
      this.pageSize = 1
      this.getPostList()
    },
    changeRoleLevle: function () {
      this.pageNum = 1
      this.pageSize = 1
      this.getPostList()
    },
    ckmorePeople: function(id) {
      this.dialogVisible = true;
      this.getMoreUser(id);
    },
    handleCurrentChange: function(e) {
      this.postPageNum = e;
      this.getPostList();
    },
    getMoreUser: function(id) {
      let that = this;
      that.loading1 = true;
      let data = {
        userId: id
      };
      axios({
        method: "POST",
        url: Config.path + "/api/platform/user/getMyUserInvitation",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json"
        },
        data: data
      })
        .then(res => {
          that.loading1 = false;
          if (res.data.success === "1") {
            that.peoList = res.data.content;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    getPostList: function() {
      let that = this;
      that.loading = true;
      let data = {
        pageNum: that.postPageNum,
        pageSize: that.postPageSize,
      };
      if (this.roleLevle !== '') {
        data.roleLevle = this.roleLevle
      }
      if (this.roleLable !== '') {
        data.roleLable = this.roleLable
      }
      if (this.phone !== '') {
        data.phone = this.phone
      }
      axios({
        method: "POST",
        url: Config.path + "/api/platform/user/getUserList",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json"
        },
        data: data
      })
        .then(res => {
          that.loading = false;
          if (res.data.success === "1") {
            that.postList = res.data.content.list;
            that.postPageTotle = res.data.content.total;
          } else if (response.data.success === "111111") {
            that.$router.push({
              path: "/login"
            });
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch(err => {
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    }
  },
  mounted: function() {
    this.getPostList();
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myPostIndex {
  width: 100vw;
  height: calc(100vh - 100px);
  padding-top: 1px;
  position: relative;
  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 30px;
    left: 50%;
    transform: translateX(-50%);
    // background-color: rgb(83, 152, 133);
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;
    .el-pager {
      li {
        background: transparent;
        color: #ffffff;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }

  .cont {
    width: calc(100% - 60px);
    height: calc(100vh - 200px);
    background-color: #ffffff;
    border-radius: 8px;
    position: absolute;
    top: 50%;
    left: 50%;
    padding: 30px;
    box-sizing: border-box;
    transform: translate(-50%, -50%);
    overflow: hidden;
    overflow-y: scroll;

    // .selectCont {

    //     .el-radio-group {
    //         margin-left: 40px;

    //         .el-radio-button__inner {
    //             background-color: transparent;
    //             color: #fff;
    //         }

    //         .is-active {
    //             .el-radio-button__inner {
    //                 background-color: #ffffff;
    //                 color: #5DC2D0;
    //                 border-color: #5DC2D0;
    //             }
    //         }
    //     }
    // }

    // .tableCont {
    //     margin-top: 30px;

    //     * {
    //         background-color: transparent;
    //         color: #ffffff;
    //     }

    //     .el-table--group,
    //     .el-table--border {
    //         border: none;

    //         &:after {
    //             border: none;
    //         }
    //     }

    //     .el-table--group,
    //     .el-table--border {
    //         border: none;
    //     }

    //     .el-table--border th,
    //     .el-table--border td {
    //         border: none;
    //     }

    //     .el-table--group::after,
    //     .el-table--border::after,
    //     .el-table::before {
    //         height: 0;
    //         width: 0;
    //     }

    //     .el-table__header-wrapper {
    //         border-bottom: 1px solid #ffffff;
    //     }

    //     .el-table__body tr {
    //         >td {
    //             span {
    //                 margin: 0 5px;
    //             }
    //         }

    //         &:hover {
    //             >td {
    //                 background-color: #ffffff;

    //                 div {
    //                     color: #5DC2D0;
    //                 }

    //                 span {
    //                     color: #5DC2D0;
    //                     margin: 0 5px;
    //                 }
    //             }
    //         }
    //     }
    // }
  }
  .dsbox{
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-direction: row;
  }
}
</style>
